module.exports = __webpack_public_path__ + "static/assets/88a3bec89367b65d176c22eef8c6ddcd.svg";